import { createGlobalStyle, css } from "styled-components";

import { subnavHeight } from "common/constants/navbarHeight";
import { createScrollbarStyle } from "common/styles";

const styles = css`
  html {
    background-color: ${({ theme }) => theme.colors.backgroundPrimary};
    scroll-padding-top: ${subnavHeight};

    ${createScrollbarStyle()}
  }
`;

// Prettier does not format tagged templates correctly when the parsing function is createGlobalStyle.
export const GlobalStyles = createGlobalStyle`
  ${styles}
`;
